export default __webpack_public_path__ + "fonts/af0176456caea63de0507f49748e4c96.svg";